import {json2csv}  from 'json-2-csv';

const downloadBlob = ({blob, filename}) => {
	try {

		// Create a Blob from the zipped data.
		//const blob = new Blob([zippedData], { type: "application/zip" });

		// Create an object URL for the Blob.
		const url = window.URL.createObjectURL(blob);

		// Create a temporary anchor element and set the download attribute.
		const link = document.createElement("a");
		link.href = url;
		link.download = filename;

		// Append the link to the document and trigger a click.
		document.body.appendChild(link);
		link.click();

		// Clean up: remove the link and revoke the object URL.
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);

	} catch (error) {
		throw error;
	}
}


const downloadCsv = ({data, filename}) => {
	try {
		const csvdata = json2csv(data);
		const uint8 = new TextEncoder().encode(csvdata);
		const blob = new Blob([uint8],{type: "text/csv"});
		downloadBlob({blob, filename});

	} catch (error) {
		throw error;
	}
}

export {downloadBlob, downloadCsv};